import React from "react"
import IndexStyles from "./index.less"
import {Props, State} from "../../util/interfaceData"
import List from "../list/list"
import UploadAndDisplay from "../uploadAndDisplay/uploadAndDisplay"
import {connect} from "react-redux"

// eslint-disable-next-line react/prefer-stateless-function
class ModelTest extends React.Component<Props, State, {}> {
    constructor(props: Props) {
        super(props)
    }
    render() {
        return (
            <div className={IndexStyles.modelTestBox}>
                <div className={IndexStyles.subject}>
                    {this.props.hasUpload ? <UploadAndDisplay /> : null}
                    <List />
                </div>
            </div>
        )
    }
}

export default connect((state: any) => {
    return {
        hasUpload: state.hasUpload,
    }
})(ModelTest)
